var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"muicy-box"},[_c('div',{staticClass:"PlayEy"}),_c('div',{staticClass:"Btn"}),_c('div',{staticClass:"Play"},[_c('audio',{attrs:{"id":"audios","src":_vm.domianURL+'/'+_vm.musicpath,"loop":"true","autoplay":"true"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }